import React, { useContext } from 'react';
import { IFrame as Iframe, TmoCard } from '@tmobile/tmo-bps-syncup-web-component-lib';

import config from '../../../configs/config';
import SyncUpProductContext from '../../../context/SyncUpProductContext';

const {
  iframeAppEngagementPetsURL,
  iframeAppEngagementTrackerURL,
  iframeAppEngagementWatchURL
} = config.powerBiSettings;

function AppEngagement() {
  const syncUpProductContext = useContext(SyncUpProductContext);
  const iframe = () => {
    switch (syncUpProductContext.syncUpAppName) {
      case 'TRACKER':
        return iframeAppEngagementTrackerURL;
      case 'KIDSWATCH':
        return iframeAppEngagementWatchURL;
      default:
        return iframeAppEngagementPetsURL;
    }
  };

  return (
    <TmoCard>
      <Iframe src={iframe()} width="100%" height="836px" />
    </TmoCard>
  );
}

export default AppEngagement;
